import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useMarketplaceAffiliateJoinedInfluencersQuery } from '@anytag/graphql';
import {
  MarketplaceJoinedInfluencersList,
  MarketplaceJoinedInfluencersFilter,
  useMarketplaceJoinedInfluencersFilter
} from '@anytag/shared-organisms';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';

export const MarketplaceJoinedInfluencers = () => {
  const { marketplace, marketplaceId } = useMarketplaceDetailsContext();
  const { page, limit, filter } = useMarketplaceJoinedInfluencersFilter();
  const { data, previousData, loading } = useMarketplaceAffiliateJoinedInfluencersQuery({
    variables: getValuableVariables({
      limit,
      marketplaceId,
      keyword: filter.keyword,
      offset: getOffset(page, limit)
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.marketplaceAffiliateJoinedInfluencersCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <MarketplaceJoinedInfluencersFilter marketplaceId={marketplaceId} />
      <MarketplaceJoinedInfluencersList
        loading={loading}
        marketplace={marketplace}
        data={result?.marketplaceAffiliateJoinedInfluencers || []}
      />
    </ListWithPagination>
  );
};
